import type { Error } from '../types';

export const mustNotContain =
  (value: string | undefined, message?: Error['message']) =>
  (inputValue: string | undefined): Error => ({
    valid: !value || !inputValue || !inputValue.toLowerCase().includes(value.toLowerCase()),
    message
  });
